import { assignLeft, createTypes, createActions, createReducer } from './util'
import _ from 'lodash/fp'

const namespace = 'ghostUsers'

const typeKeys = [
  'NEW_GHOST',
  'SYNC_REQUEST',
  'SYNC_SUCCESS',
  'SYNC_ERROR',
  'SYNC_DONE',
  'CLEAR'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

export const initialState = {
  items: {
    // what's loaded from the server
  },
  // sync
  syncStartedAt: null,
  syncError: null,
  syncedAt: null
}

const reducer = {
  [types.NEW_GHOST]: p => s => {
    return _.update(
      ['items'], assignLeft({ [p.id]: p })
    )(s)
  },
  [types.SYNC_REQUEST]: p => _.flow(
    _.set('saveStartedAt', Date.now()),
    _.set('syncError', null)
  ),
  [types.SYNC_SUCCESS]: p => _.flow(
    _.set('syncedAt', Date.now()),
    _.update(['items'], _.omitBy((v, k) => v.synced)),
    _.update(['items'], assignLeft(p))
  ),
  [types.SYNC_ERROR]: p => _.set('syncError', Date.now()),
  [types.SYNC_DONE]: p => _.set('syncStartedAt', null),
  [types.CLEAR]: p => _.set('items', {})
}

export default createReducer(initialState, reducer)

function createSelectors () {
  const allGhosts = _.flow(_.get(`${namespace}.items`), _.values)
  const unsyncedGhosts = _.flow(allGhosts, _.reject('synced'))
  return {
    getIds: _.flow(_.get('items'), _.keys), // oldie
    getAll: (state) => _.values(state.items), // oldie
    // this is the new style thing that can be called globally
    getGhostIds: _.flow(_.get(`${namespace}.items`), _.keys),
    allGhosts,
    unsyncedGhosts
  }
}

export const selectors = createSelectors()
